// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__-7-sX","rootCenter":"LoadMoreObserver_rootCenter__2SfdI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__24K6m"};